import React, { Component, Fragment } from "reactn";

export default class BackgroundClick extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
    }

    handleDocumentMouseDown = event => {
        if (this.ref.current.contains(event.target)) {
            return;
        }
        this.props.onBackgroundClick();
    }

    render() {
        return (
            <div ref={this.ref}>
                {this.props.children}
            </div>
        );
    }
}
